import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Header from 'components/Header';
import Loading from 'components/Loading';
import Empty from 'components/EmptyItem/index.jsx';
import styles from './index.less';
import { getAgentId, getLanguage } from '@/utils/getValue';
import { getShowTopBar } from '../../utils/getValue';

const languageMap = {
  'zh-cn': {
    Title: '可用服务网络',
    Placeholder: '请输入城市/网点名称',
    jn: '境内机场',
    jw: '境外机场/中国港澳台',
    gt: '高铁',
  },
  en: {
    Title: 'Available Service Network',
    Placeholder: 'Please enter the city/outlet name',
    jn: 'Mainland China',
    jw: 'Outside Mainland China',
    gt: 'Railway Station',
  },
};

@connect(({ search, loading }) => ({
  tabs: search.tabs,
  listData: search.listData,
  allData: search.allData,
  searchData: search.searchData,
  selectTab: search.selectTab,
  loading: loading.effects['search/queryNetworkList'],
}))
class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showClear: false,
      agentId: '', // 获取列表用的数据
    };
  }

  componentDidMount() {
    // 动态改变
    const query = this.props.location.query || {};
    const { netwrokType, dragoncode } = query;
    const language = getLanguage();
    const agentId = getAgentId();
    this.setState({
      agentId,
    });
    if (netwrokType === 'meal') {
      const { yuyueCode, projectId } = query;
      this.props.dispatch({
        type: 'search/queryNetworkList',
        payload: {
          netwrokType,
          language,
          yuyueCode,
          projectId,
        },
      });
      return;
    }
    this.props.dispatch({
      type: 'search/queryNetworkList',
      payload: {
        netwrokType,
        agentId,
        language,
        dragoncode,
        ...query,
      },
    });
  }

  onSelect = (key) => {
    this.props.dispatch({
      type: 'search/setData',
      payload: {
        selectTab: key,
      },
    });
  };

  toAirport = (el) => {
    const { query = {} } = this.props.location;
    const { id, enId, name, enName, code } = el;
    const { netwrokType, yuyueCode, projectId } = query;
    const language = getLanguage();
    const sid = language === 'en' ? enId : id;
    const _name = language === 'en' ? enName : name;
    const type = this.props.selectTab; // 网点类型
    if (netwrokType === 'cip') {
      delete query.netwrokType;
      router.push({
        pathname: '/cip/networkDetail',
        query: {
          airportCode: code,
          from: 'search',
          type,
          ...query,
        },
      });
      return;
    }
    if (netwrokType === 'meal') {
      router.push({
        pathname: '/meal/networkDetail',
        query: {
          sid,
          name: _name,
          language,
          yuyueCode,
          projectId,
          type,
        },
      });
      return;
    }
    router.push({
      pathname: '/airport',
      query: {
        sid,
        name: _name,
        language,
        type,
      },
    });
  };

  handleKeyUp = (e) => {
    const { allData } = this.props;
    const value = e.target.value;
    let arr = [];
    if (value.trim() === '') {
      arr = allData;
    } else {
      try {
        // 是否中文
        const isZhcn = getLanguage() === 'zh-cn';
        allData.forEach((el, i) => {
          const elData = isZhcn ? el : el.enTrafficsite;
          const { name = '', iataCode = '', enName = '', country = '' } = elData || {};
          // 全部转大写判断
          const upperCaseVal = value.toUpperCase();
          const upperCaseName = name.toUpperCase();
          const upperCaseEnName = enName; // 在全部数据处理时候已转大写，所以不用转。因为有些旧的网点没有返回enTrafficsite，会导致报错
          const upperCaseIataCode = iataCode.toUpperCase();
          const upperCaseCountry = country.toUpperCase();

          const hasName = upperCaseName?.indexOf(upperCaseVal) >= 0;
          const hasenName = upperCaseEnName?.indexOf(upperCaseVal) >= 0;
          const hasIataCode = upperCaseIataCode?.indexOf(upperCaseVal) >= 0;
          const hasCountry = upperCaseCountry?.indexOf(upperCaseVal) >= 0;
          const isHase = hasName || hasenName || hasIataCode || hasCountry;
          if (isHase) {
            arr.push(el);
          }
        });
      } catch (error) {
        console.log('搜索报错', error);
      }
    }
    this.props.dispatch({
      type: 'search/setData',
      payload: {
        searchData: arr,
      },
    });
  };

  handleFocus = () => {
    this.setState({ showClear: true });
  };

  handleClear = () => {
    this.setState({ showClear: false });
    this.keyword.value = '';
    this.props.dispatch({
      type: 'search/setData',
      payload: {
        searchData: [],
      },
    });
  };

  onScroll = (tag) => {
    const a = document.querySelector(`#${tag}`);
    if (a) {
      // eslint-disable-next-line no-multi-assign
      document.documentElement.scrollTop = document.body.scrollTop = a.offsetTop - 150;
    }
  };
  itemDom(el, idx, lg) {
    const isEn = lg === 'en'; // 是否英文
    let { name, iataCode, country, city, enTrafficsite } = el;
    let airportName = name; // 机场名
    let countryName = country; // 城市名
    let cityName = city;
    if (lg === 'en' && enTrafficsite) {
      airportName = enTrafficsite.name;
      countryName = enTrafficsite.country;
      cityName = enTrafficsite.city;
    }
    return (
      <div className={styles.list} onClick={() => this.toAirport(el)} key={idx}>
        <div className={styles.listTop}>
          <span className={styles.left}>{airportName}</span>
          <span className={styles.right}>{countryName}</span>
        </div>
        <div className={styles.listBottom}>
          <span className={styles.left}>{iataCode}</span>
          <span className={styles.right}>{cityName}</span>
        </div>
      </div>
    );
  }
  render() {
    const { showClear, agentId } = this.state;
    const { listData, searchData, loading, selectTab, tabs } = this.props;

    const { keys = [], list = [] } = listData[selectTab] || {};
    const zimu = keys;
    const lg = getLanguage();
    const channel = localStorage.getItem('channel');
    const showTopBar = getShowTopBar();
    return (
      <Fragment>
        <Header title={languageMap[lg].Title} />

        <Loading loading={loading}>
          <div
            className={styles.searchWrap}
            style={{
              top: showTopBar ? '1rem' : '0',
            }}
          >
            <div className={styles.searchInner}>
              <input
                placeholder={languageMap[lg].Placeholder}
                ref={(input) => (this.keyword = input)}
                onFocus={this.handleFocus}
                onChange={this.handleKeyUp}
              />
              {showClear ? (
                <img
                  className={styles.clear}
                  src={require('images/ico_clear_content@2x.png')}
                  alt=""
                  onClick={this.handleClear}
                />
              ) : null}
            </div>
            {!showClear && (
              <div className={channel === 'spdb' ? styles.spdbWrap : styles.tabWrap}>
                {tabs.map((item) => {
                  return (
                    <div
                      key={item.key}
                      className={selectTab === item.key ? styles.selected : ''}
                      style={{ flex: item.key === 'jw' ? 1.5 : 1 }}
                      onClick={() => this.onSelect(item.key)}
                    >
                      {languageMap[lg][item.key]}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {!showClear && (
            <div
              style={{
                paddingTop: showTopBar ? '3rem' : '2rem',
              }}
            >
              <div className={styles.listWrap}>
                {keys.map((key) => {
                  const airList = list[key] || [];
                  return (
                    <div className={styles.listInner} key={key}>
                      <div className={styles.sort} id={key}>
                        {key}
                      </div>
                      {airList.map((el, j) => {
                        return this.itemDom(el, j, lg);
                      })}
                    </div>
                  );
                })}

                <div className={styles.zimu}>
                  {zimu &&
                    zimu.map((item) => {
                      return (
                        <div key={item} onClick={() => this.onScroll(item)}>
                          {item}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </Loading>

        {showClear ? (
          <div className={styles.dialog}>
            <div className={styles.dialogInner}>
              {searchData.length === 0 && <Empty style={{ marginTop: '2rem' }} />}
              {searchData.length !== 0 &&
                searchData.map((item, index) => {
                  return this.itemDom(item, index, lg);
                })}
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default Search;
